// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {GraphQlDocument, HookVariables} from '@sail/data';

import type {
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  V1MutationReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1CryptoInternalRelayQuoteInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation RequestRelayQuoteMutation(
    $input: OpenapiPostV1CryptoInternalRelayQuoteInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalRelayQuote(input: $input, v1Context: $v1Context) {
      depositAddress: deposit_address
      inputAmount: input_amount
      inputChain: input_chain
      inputCurrency: input_currency
    }
  }
`;

export const requestRelayQuoteMutation: RequestRelayQuoteMutationDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const requestRelayQuoteMutationOptions: V1MutationOptionsWithoutVariables<RequestRelayQuoteMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useRequestRelayQuoteMutation<
  THookVariables extends HookVariables<RequestRelayQuoteMutationVariables> = {},
>(
  options: V1MutationOptions<
    RequestRelayQuoteMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<RequestRelayQuoteMutationDocument, THookVariables> {
  return useV1Mutation(requestRelayQuoteMutation, {
    ...requestRelayQuoteMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RequestRelayQuoteMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1CryptoInternalRelayQuoteInput>;
  v1Context: V1ContextInput;
}>;

export type RequestRelayQuoteMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalRelayQuote: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceRelayQuote';
    readonly depositAddress: string;
    readonly inputAmount: string;
    readonly inputChain: string;
    readonly inputCurrency: string;
  } | null;
};

export type RequestRelayQuoteMutationToken = AccountToken<{
  Mutation_v1CryptoInternalRelayQuote: true;
}>;

export type RequestRelayQuoteMutationDocument = GraphQlDocument<
  RequestRelayQuoteMutationData,
  RequestRelayQuoteMutationVariables,
  RequestRelayQuoteMutationToken
>;
